export default __webpack_public_path__ + "static/media/bike_repair.431ebd05.svg";